import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { inc, dec } from './counterSlice'

const Counter = () => {
    const dispatch = useDispatch()
    const count = useSelector((state)=>
        state.counter.count
    )
  return (
    <>
        <button onClick={()=>{
            dispatch(dec())
        }}>-</button>
         Count : {count}
        <button onClick={()=>{
            dispatch(inc())
        }}>+</button>
    </>
  )
}

export default Counter